import { createClient } from "@supabase/supabase-js";

// Server-side Supabase client
let serverSupabase: any = null;

if (typeof window === "undefined") {
  // Only access process.env on server side
  const supabaseUrl = process.env.SUPABASE_URL!;
  const supabaseAnonKey = process.env.SUPABASE_ANON_KEY!;

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error("Missing Supabase environment variables");
  }

  serverSupabase = createClient(supabaseUrl, supabaseAnonKey);
}

export const supabase = serverSupabase;

// Client-side Supabase client for browser (싱글톤)
let clientSupabase: any = null;

export const createSupabaseClient = () => {
  // Check if we're in the browser
  if (typeof window === "undefined") {
    // Return server-side client for SSR
    return serverSupabase;
  }

  // 이미 클라이언트가 생성되었다면 기존 인스턴스 반환
  if (clientSupabase) {
    return clientSupabase;
  }

  // 새로운 클라이언트 인스턴스 생성 (한 번만)
  clientSupabase = createClient(
    (window as any).ENV.SUPABASE_URL,
    (window as any).ENV.SUPABASE_ANON_KEY
  );

  return clientSupabase;
};
